/**
 * Delt hjælper til BreadcrumbList-structured data.
 * Bruges så alle sider bygger brødkrummer ens og med korrekte absolutte URL'er.
 */
const SITE_URL = 'https://minnyeelbil.dk';

export interface Crumb {
  name: string;
  path: string;
}

export function breadcrumbJsonLd(crumbs: Crumb[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.name,
      item: `${SITE_URL}${c.path.startsWith('/') ? c.path : `/${c.path}`}`,
    })),
  };
}

export const HOME_CRUMB: Crumb = { name: 'Forside', path: '/' };
